import { useState } from "react";
import { Menu, X, ChevronDown } from "lucide-react";
import { Link } from "react-router-dom";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { ConsultationForm } from "./ConsultationForm";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);

  const menuItems = [
    { name: "Home", href: "/" },
    { name: "About", href: "/about" },
    { name: "Store", href: "/store" },
    { name: "Blog", href: "/blog" },
    { name: "Contact", href: "/contact" },
  ];

  const serviceItems = [
    { name: "Facial Aesthetics", href: "/services/facial-aesthetics" },
    { name: "Hair Restoration", href: "/services/hair-restoration" },
    { name: "IV Therapy", href: "/services/iv-therapy" },
    { name: "Body Treatments", href: "/services/body-treatments" },
    { name: "Neurotoxins", href: "/services/neurotoxins" },
    { name: "Fillers", href: "/services/fillers" },
    { name: "Chemical Peels", href: "/services/peels" },
    { name: "Facials", href: "/services/facials" },
    { name: "Cryolipolysis", href: "/services/cryolipolysis" },
    { name: "FUE Hair Restoration", href: "/services/fue-hair-restoration" },
    { name: "PRP Therapy", href: "/services/prp" },
    { name: "Exosomes", href: "/services/exosomes" },
    { name: "Red Light Laser", href: "/services/red-light-laser" },
    { name: "Hair Supplements", href: "/services/hair-supplements" },
    { name: "Mesotherapy", href: "/services/mesotherapy" },
    { name: "IPL", href: "/services/ipl" },
    { name: "GLP1 Therapy", href: "/services/glp1-therapy" },
  ];

  return (
    <nav className="fixed w-full bg-white/90 backdrop-blur-sm z-50 py-4 px-6 shadow-sm">
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        <Link to="/" className="flex items-center">
          <img 
            src="/lovable-uploads/90e43581-7f0e-40b5-b575-42a2b2f71ab8.png" 
            alt="Evolutions Medspa Logo" 
            className="h-16 w-auto"
          />
        </Link>

        {/* Desktop Menu */}
        <div className="hidden md:flex space-x-8">
          <DropdownMenu>
            <DropdownMenuTrigger className="text-secondary hover:text-primary transition-colors flex items-center gap-1">
              Services <ChevronDown size={16} />
            </DropdownMenuTrigger>
            <DropdownMenuContent className="w-56 bg-white">
              {serviceItems.map((item) => (
                <DropdownMenuItem key={item.name} asChild>
                  <Link to={item.href} className="w-full">
                    {item.name}
                  </Link>
                </DropdownMenuItem>
              ))}
            </DropdownMenuContent>
          </DropdownMenu>

          {menuItems.map((item) => (
            <Link
              key={item.name}
              to={item.href}
              className="text-secondary hover:text-primary transition-colors"
            >
              {item.name}
            </Link>
          ))}
          <Dialog>
            <DialogTrigger className="text-secondary hover:text-primary transition-colors font-semibold">
              Schedule Consultation
            </DialogTrigger>
            <DialogContent className="sm:max-w-[425px]">
              <DialogHeader>
                <DialogTitle>Schedule a Consultation</DialogTitle>
              </DialogHeader>
              <ConsultationForm />
            </DialogContent>
          </Dialog>
        </div>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden text-secondary"
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? <X size={24} /> : <Menu size={24} />}
        </button>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="absolute top-full left-0 right-0 bg-white shadow-lg md:hidden">
            <div className="flex flex-col p-4">
              <DropdownMenu>
                <DropdownMenuTrigger className="py-2 text-left text-secondary hover:text-primary transition-colors flex items-center gap-1">
                  Services <ChevronDown size={16} />
                </DropdownMenuTrigger>
                <DropdownMenuContent className="w-56">
                  {serviceItems.map((item) => (
                    <DropdownMenuItem key={item.name} asChild>
                      <Link 
                        to={item.href} 
                        className="w-full"
                        onClick={() => setIsOpen(false)}
                      >
                        {item.name}
                      </Link>
                    </DropdownMenuItem>
                  ))}
                </DropdownMenuContent>
              </DropdownMenu>
              {menuItems.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  className="py-2 text-secondary hover:text-primary transition-colors"
                  onClick={() => setIsOpen(false)}
                >
                  {item.name}
                </Link>
              ))}
              <Dialog>
                <DialogTrigger className="py-2 text-secondary hover:text-primary transition-colors font-semibold text-left">
                  Schedule Consultation
                </DialogTrigger>
                <DialogContent className="sm:max-w-[425px]">
                  <DialogHeader>
                    <DialogTitle>Schedule a Consultation</DialogTitle>
                  </DialogHeader>
                  <ConsultationForm />
                </DialogContent>
              </Dialog>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;